import { userSettings$ } from '../../../NonReact/common/RxJS/UserSettingsState'
import { useRxJSState } from './useRxJSState'
import { ApplicationResponseNotification } from '../../../NonReact/common/Types/Types'

export type UserSettings = [
    Definable<ApplicationResponseNotification>,
    (data?: ApplicationResponseNotification) => void
]

export const useUserSettings = (): UserSettings => useRxJSState<ApplicationResponseNotification>(userSettings$)
